import { createSlice } from '@reduxjs/toolkit';
import { formatISO } from 'date-fns';

export const appointmentSlice = createSlice({
  name: 'appointment',
  initialState: {
    globalAppId: null,
    appPeriodFilter: {
      name: 'day',
      startDate: formatISO(new Date()),
      endDate: formatISO(new Date()),
    },
    appSearchPrams: {
      allProviders: 0,
      status: '',
      searchNameString: '',
      searchContactString: '',
      showAutoMaticOnPageLoad: 0,
      sortOrder: 'apptime',
      clinicLocation: '',
      createVYesNo: 0,
      reminderStatus: '',
      tov: '',
      actStatus: '',
      payor: '',
    },
    grpAppPats: [],
    grpAppArivedPats: [],
    grpApp: false,
    appPopup: false,
    appReschedule: {
      status: false,
      text: '',
      appStatusAutoId: 0,
    },
    bookNewApp: {
      status: false,
    },
    appPatSerchPopup: false,
    recurPopupSataus: {
      status: false,
      type: 0,
      recurringId: 0,
    },
    isCheckoutProcess: {
      status: false,
      appid: null,
      curStatAutoIncId: null,
    },
    appPopUpFacility: 0,
    patAlertData: [],
    patSrchDiasbled: false,
  },
  reducers: {
    setAppPerriodFilter: (state, action) => {
      state.appPeriodFilter = action.payload;
    },
    setGrpApp: (state, action) => {
      state.grpApp = action.payload;
    },
    setAppPopup: (state, action) => {
      state.appPopup = action.payload;
    },
    setGrpAppPats: (state, action) => {
      state.grpAppPats = [...state.grpAppPats, action.payload];
    },
    setGrpAppArivedPats: (state, action) => {
      state.grpAppArivedPats = action.payload;
    },
    setGrpAppPatsNull: (state, action) => {
      state.grpAppPats = action.payload;
    },
    setGlobalAppId: (state, action) => {
      state.globalAppId = action.payload;
    },
    handReSchedule: (state, action) => {
      state.appReschedule = action.payload;
    },
    bookNewAppWithApp: (state, action) => {
      state.bookNewApp = action.payload;
    },
    updateGrpAppPats: (state, action) => {
      state.grpAppPats = [
        ...state.grpAppPats.filter(
          (data) => parseInt(data.userId) !== parseInt(action.payload),
        ),
      ];
    },
    updateSearchParams: (state, action) => {
      const { key, value } = action.payload;
      if (Object.prototype.hasOwnProperty.call(state.appSearchPrams, key)) {
        state.appSearchPrams[key] = value;
      }
    },
    setAppPatSerchPopup: (state, action) => {
      state.appPatSerchPopup = action.payload;
    },
    setAppPrecurrencePopup: (state, action) => {
      state.recurPopupSataus = action.payload;
    },
    setIsCheckoutProcess: (state, action) => {
      state.isCheckoutProcess = action.payload;
    },
    setAppPopupFacility: (state, action) => {
      state.appPopUpFacility = action.payload;
    },
    setPatAlertData: (state, action) => {
      state.patAlertData = action.payload;
    },
    updatePatAlertData: (state, action) => {
      state.patAlertData.getSpecificAlertData = action.payload;
    },
    updatePatAlertStatus: (state, action) => {
      state.patAlertData.alertActive = action.payload;
    },
    setPatSrchDiasbled: (state, action) => {
      state.patSrchDiasbled = action.payload;
    },
  },
});

export const {
  setAppPerriodFilter,
  setGrpApp,
  setAppPopup,
  updateSearchParams,
  setGrpAppPats,
  setGrpAppArivedPats,
  updateGrpAppPats,
  setGrpAppPatsNull,
  setGlobalAppId,
  handReSchedule,
  bookNewAppWithApp,
  setAppPatSerchPopup,
  setAppPrecurrencePopup,
  setIsCheckoutProcess,
  setAppPopupFacility,
  setPatAlertData,
  updatePatAlertData,
  updatePatAlertStatus,
  setPatSrchDiasbled,
} = appointmentSlice.actions;
export default appointmentSlice.reducer;
